import { render, staticRenderFns } from "./ShopOrganizationAccess.vue?vue&type=template&id=02580c64&scoped=true&"
import script from "./ShopOrganizationAccess.vue?vue&type=script&lang=js&"
export * from "./ShopOrganizationAccess.vue?vue&type=script&lang=js&"
import style0 from "./ShopOrganizationAccess.vue?vue&type=style&index=0&id=02580c64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02580c64",
  null
  
)

export default component.exports